import * as React from 'react';
import * as className from 'classnames';
import { MarkdownToolbarButton } from './MarkdownToolbarButton';
import { EditLinkBar } from 'lib/editor/DraftEditor/plugins/linkPlugin/EditLinkBar';
import { InsertImageButton } from 'lib/editor/DraftEditor/plugins/imagePlugin/InsertImageButton';
import { theme } from './theme';

export class MarkdownToolbar extends React.Component {
	render() {
		const { onCommand, onQuery } = this.props;

		const Command = ({ command, icon = command, title, children }) => {
			const onClick = evt => onCommand(command, title, evt);
			const { actived, disabled } = onQuery(command);
			return (
				<MarkdownToolbarButton {...{ onClick, actived, disabled }}>
					<i className={`qa-ico-${icon}`} title={title}>{children}</i>
				</MarkdownToolbarButton>
			);
		}

		const InsertLink = () => {
			return (
				<MarkdownToolbarButton onClick={evt => {
					const button = evt.target;
					const buttonPosition = Math.floor(button.offsetLeft + button.clientWidth / 2);
					this.linkEditor.getInstance().active('', buttonPosition);
				}}>
					<i className={`qa-ico-link`} title="插入连接">L</i>
				</MarkdownToolbarButton>
			);
		}

		const InsertImage = () => {
			return (
				<InsertImageButton
					theme={theme}
					onInsert={files => onCommand('image', files && files[0])}>
				</InsertImageButton>
			);
		}

		return (
			<div className="qa-r-editor-toolbar">
				<section className="qa-r-editor-btns">
					<Command command="bold" title="加粗">B</Command>
					<Command command="italic" title="斜体">I</Command>
					<Command command="strike" title="删除">S</Command>
					<Command command="code" title="代码">C</Command>
					<Spliter />
					<Command command="h1" title="一级标题">h1</Command>
					<Command command="h2" title="二级标题">h2</Command>
					<Command command="h3" title="三级标题">h3</Command>
					<Spliter />
					<Command command="quote" icon="blockquote" title="引用">Q</Command>
					<Command command="code-block" title="代码块">C</Command>
					<Command command="ol" title="编号">O</Command>
					<Command command="ul" title="列表">L</Command>
					<Spliter />
					<InsertLink />
					<Command command="formula" icon="sigma" title="公式">Σ</Command>
					<InsertImage />
					<Command command="table" title="表格">T</Command>
					<Spliter />
					<Command command="preview" title="预览">E</Command>
				</section>
				<EditLinkBar
					ref={bar => this.linkEditor = bar}
					onSave={url => onCommand('link', url)}
				/>
			</div>
		);
	}
}

function Spliter() {
	return <span className="qa-r-editor-spliter">|</span>;
}



// WEBPACK FOOTER //
// ./lib/editor/MarkdownEditor/toolbar/MarkdownToolbar.jsx